import { render, staticRenderFns } from "./CompServiceCard.vue?vue&type=template&id=1317f3f6&scoped=true"
import script from "./CompServiceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompServiceCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1317f3f6",
  null
  
)

export default component.exports